module.exports = __webpack_public_path__ + "img/first-page.e323f4f9.svg";